"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.requestSignatureRequestSchema = void 0;
const zod_1 = require("zod");
const longField_schema_1 = require("../../../common/schemas/longField.schema");
const userWithUserId_schema_1 = require("../../../common/schemas/userWithUserId.schema");
const contact_schema_1 = require("../../../common/schemas/contact.schema");
const attachments_schema_1 = require("../../../common/schemas/attachments.schema");
exports.requestSignatureRequestSchema = zod_1.z
    .object({
    remarks: longField_schema_1.longFieldSchema.optional(),
    from: userWithUserId_schema_1.userWithUserIdSchema,
    to: contact_schema_1.contactSchema,
    cc: contact_schema_1.contactSchema.array().optional(),
    version: zod_1.z.string(),
    attachments: attachments_schema_1.attachmentsSchema,
})
    .strict();
//# sourceMappingURL=requestSignatureRequest.schema.js.map